<template>
  <div class="reservation-promo">
    <div class="card-header bg-default">
      {{ reservationPromo.code }}
      <span class="badge" :class="randomLabel(reservationPromo.percentDiscount)">
        {{ reservationPromo.percentDiscount }}% Discount
      </span>
    </div>
    <div class="list-group list-group-flush">
      <div class="list-group-item">
        <strong>Description</strong><br>
        {{ reservationPromo.description }}
      </div>
      <div class="list-group-item">
        <strong>Account Types</strong>
        <template v-for="accountType in reservationPromo.AccountTypes">
          <p class="mb-0" :key="accountType.uuid">
            <router-link :to="{ path: '/membership/plans/' + accountType.uuid }">
              {{ accountType.name }}
            </router-link>
          </p>
        </template>
      </div>
      <div class="list-group-item">
        <strong>Cars</strong>
        <template v-for="car in reservationPromo.Cars">
          <p class="mb-0" :key="car.uuid">
            <router-link :to="{ path: '/fleet/vehicles/' + car.uuid }">
              {{ car.dropdownLabel }}
            </router-link>
          </p>
        </template>
      </div>
      <div class="list-group-item">
        <strong>Expiration Type:</strong><br/>
        <template v-if="reservationPromo.expirationType === 'scheduled'">
          <span class="fa fa-calendar-alt"></span> Scheduled
        </template>
        <template v-if="reservationPromo.expirationType === 'permanent'">
          <span class="fa fa-percent"></span> Permanent
        </template>
        <template v-if="reservationPromo.expirationType === 'limitedUse'">
          <span class="fa fa-ban"></span> Limited Use
        </template>
      </div>
      <div class="list-group-item" v-if="reservationPromo.expirationType === 'scheduled'">
        <strong>Valid From</strong> {{ reservationPromo.startDate | short_date_format }}<br>
        <strong>Expires On</strong> {{ reservationPromo.endDate | short_date_format }}
      </div>
      <div class="list-group-item" v-if="reservationPromo.expirationType === 'limitedUse'">
        <strong>Usage Limit</strong> {{ reservationPromo.usageLimit }}
      </div>
      <div class="list-group-item">
        <strong>Minimum Booking Period</strong> {{ humanizedPeriod }}
      </div>
    </div>
    <div class="card-footer text-right">
      <router-link class="btn btn-sm btn-primary"
        :to="{ path: `/membership/reservation-promotions/edit/${reservationPromo.uuid}` }">
        <span class="fa fa-edit fa-fw"></span> Edit
      </router-link>
    </div>
  </div>
</template>

<script>
import { randomLabel } from '@/util/helpers'

export default {
  name: 'ReservationPromo',
  props: {
    object: {
      type: Object
    }
  },
  computed: {
    humanizedPeriod () {
      let str = ''
      if (this.reservationPromo.minimumBooking) {
        let days = Math.floor(this.reservationPromo.minimumBooking / 24)
        if (days > 0) {
          str = `${days} day${days > 0 ? 's' : ''}`
        }
        let hours = this.reservationPromo.minimumBooking - (days * 24.00)
        if (hours > 0) {
          if (days > 0) {
            str += ` and ${hours} hour${hours > 0 ? 's' : ''}`
          } else {
            str += `${hours} hour${hours > 0 ? 's' : ''}`
          }
        }
      }
      return str
    }
  },
  data () {
    return {
      reservationPromo: {
        uuid: '',
        code: '',
        description: '',
        startDate: new Date(),
        endDate: new Date(),
        type: '',
        expirationType: '',
        usageLimit: 0,
        amount: 0,
        OrganizationUuid: '',
        AccountType: {
          uuid: '',
          name: ''
        },
        AdjustedAccountType: {
          uuid: '',
          name: ''
        }
      }
    }
  },
  mounted () {
    this.reservationPromo = this.object
  },
  methods: {
    randomLabel (label) {
      if (!label) label = 0
      label = label.toFixed(2)
      return randomLabel(label, 'badge')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cards/ReservationPromo.vue